import { Expose } from "class-transformer";

export class CreateWarehouseConsumableDto {
  @Expose()
  warehouseId: string;

  @Expose()
  consumableId: string;

  @Expose()
  stock: number;
}
